var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoritesOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38313 7.61885C9.18765 7.42266 8.95556 7.26702 8.70011 7.16084C8.44466 7.05465 8.17086 7 7.89435 7C7.61784 7 7.34404 7.05465 7.08859 7.16084C6.83315 7.26702 6.60105 7.42266 6.40558 7.61885C6.18174 7.84341 5.81806 7.84341 5.59422 7.61885C5.19937 7.22274 4.66384 7.00021 4.10544 7.00021C3.54704 7.00021 3.01152 7.22274 2.61667 7.61885C2.22182 8.01496 2 8.55221 2 9.11239C2 9.67258 2.22182 10.2098 2.61667 10.6059L3.02235 11.0129L5.29166 13.2895C5.68244 13.6815 6.31735 13.6815 6.70813 13.2895L8.97744 11.0129L9.38313 10.6059C9.57869 10.4098 9.73383 10.177 9.83967 9.92073C9.94552 9.66446 10 9.38979 10 9.11239C10 8.835 9.94552 8.56032 9.83967 8.30405C9.73383 8.04779 9.57869 7.81495 9.38313 7.61885Z",
    fill: "#EF6D58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38313 17.6189C9.18765 17.4227 8.95556 17.267 8.70011 17.1608C8.44466 17.0547 8.17086 17 7.89435 17C7.61784 17 7.34404 17.0547 7.08859 17.1608C6.83315 17.267 6.60105 17.4227 6.40558 17.6189C6.18174 17.8434 5.81806 17.8434 5.59422 17.6189C5.19937 17.2227 4.66384 17.0002 4.10544 17.0002C3.54704 17.0002 3.01152 17.2227 2.61667 17.6189C2.22182 18.015 2 18.5522 2 19.1124C2 19.6726 2.22182 20.2098 2.61667 20.6059L3.02235 21.0129L5.29166 23.2895C5.68244 23.6815 6.31735 23.6815 6.70813 23.2895L8.97744 21.0129L9.38313 20.6059C9.57869 20.4098 9.73383 20.177 9.83967 19.9207C9.94552 19.6645 10 19.3898 10 19.1124C10 18.835 9.94552 18.5603 9.83967 18.3041C9.73383 18.0478 9.57869 17.815 9.38313 17.6189Z",
    fill: "#EF6D58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11H29",
    stroke: "#585A5E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20L29 20",
    stroke: "#585A5E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesOrange);
export default __webpack_public_path__ + "static/media/favoritesOrange.cfa36b4ab47695949efd996f9f37571d.svg";
export { ForwardRef as ReactComponent };